export default __webpack_public_path__ + "static/media/ER15.f1c17834.png";